export default "__VITE_ASSET__4f09cee5__"